// 云信相关接口

export default {
  // getNimToken: `${config.IMAjaxPrefix}/newapi/im/action`, // 获取网易云信nim token.
  getNimToken: '//m.meitun.com/newapi/router/expert-weiixin/getExpertBaseInfo', // 获取网易云信nim token.
  getRecord: '/newapi/router/expert-media/getMediaPath' // 获取录音.
};



// WEBPACK FOOTER //
// ./src/comm/api/nim/index.js